// src/services/tripService.js
import { 
  collection, 
  doc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  getDocs, 
  getDoc,
  query, 
  where, 
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';
import { db } from './firebase';

// 創建新行程
export const createTrip = async (tripData, userId) => {
  try {
    const docRef = await addDoc(collection(db, 'trips'), {
      ...tripData,
      uid: userId,
      createdAt: serverTimestamp(),
      isCompleted: false,
      isPublic: false,
      totalCost: {
        food: 0,
        accommodation: 0,
        transport: 0,
        entertainment: 0,
        other: 0
      }
    });
    return docRef.id;
  } catch (error) {
    console.error('Error creating trip:', error);
    throw error;
  }
};

// 獲取用戶的所有行程
export const getUserTrips = async (userId) => {
  try {
    const q = query(
      collection(db, 'trips'),
      where('uid', '==', userId),
      orderBy('createdAt', 'desc')
    );
    const querySnapshot = await getDocs(q);
    const trips = [];
    querySnapshot.forEach((doc) => {
      trips.push({ id: doc.id, ...doc.data() });
    });
    return trips;
  } catch (error) {
    console.error('Error getting user trips:', error);
    throw error;
  }
};

// 獲取公開行程
export const getPublicTrips = async () => {
  try {
    const q = query(
      collection(db, 'trips'),
      where('isPublic', '==', true),
      orderBy('createdAt', 'desc')
    );
    const querySnapshot = await getDocs(q);
    const trips = [];
    querySnapshot.forEach((doc) => {
      trips.push({ id: doc.id, ...doc.data() });
    });
    return trips;
  } catch (error) {
    console.error('Error getting public trips:', error);
    throw error;
  }
};

// 獲取單個行程詳情
export const getTripById = async (tripId) => {
  try {
    const docRef = doc(db, 'trips', tripId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      throw new Error('Trip not found');
    }
  } catch (error) {
    console.error('Error getting trip:', error);
    throw error;
  }
};

// 更新行程
export const updateTrip = async (tripId, updates) => {
  try {
    const docRef = doc(db, 'trips', tripId);
    await updateDoc(docRef, updates);
  } catch (error) {
    console.error('Error updating trip:', error);
    throw error;
  }
};

// 刪除行程
export const deleteTrip = async (tripId) => {
  try {
    const docRef = doc(db, 'trips', tripId);
    await deleteDoc(docRef);
  } catch (error) {
    console.error('Error deleting trip:', error);
    throw error;
  }
};

// 添加景點到行程
export const addPlaceToTrip = async (tripId, placeData) => {
  try {
    const placesCollectionRef = collection(db, 'trips', tripId, 'places');
    const docRef = await addDoc(placesCollectionRef, {
      ...placeData,
      createdAt: serverTimestamp()
    });
    return docRef.id;
  } catch (error) {
    console.error('Error adding place to trip:', error);
    throw error;
  }
};

// 獲取行程的所有景點
export const getTripPlaces = async (tripId) => {
  try {
    const placesCollectionRef = collection(db, 'trips', tripId, 'places');
    const q = query(placesCollectionRef, orderBy('start_time'));
    const querySnapshot = await getDocs(q);
    const places = [];
    querySnapshot.forEach((doc) => {
      places.push({ id: doc.id, ...doc.data() });
    });
    return places;
  } catch (error) {
    console.error('Error getting trip places:', error);
    throw error;
  }
};

// 更新景點
export const updatePlace = async (tripId, placeId, updates) => {
  try {
    const placeRef = doc(db, 'trips', tripId, 'places', placeId);
    await updateDoc(placeRef, updates);
  } catch (error) {
    console.error('Error updating place:', error);
    throw error;
  }
};

// 刪除景點
export const deletePlace = async (tripId, placeId) => {
  try {
    const placeRef = doc(db, 'trips', tripId, 'places', placeId);
    await deleteDoc(placeRef);
  } catch (error) {
    console.error('Error deleting place:', error);
    throw error;
  }
};